import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from '@studio-freight/lenis';

gsap.registerPlugin(ScrollTrigger);

export class ScrollAnimationEngine {
  constructor() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.initLenis();
    this.initGSAPAnimations();
    this.initStatsCounters();
  }

  initLenis() {
    this.lenis = new Lenis({
      duration: 1.0,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1.1,
      smoothTouch: false
    });

    this.lenis.on('scroll', () => {
      ScrollTrigger.update();
    });

    const raf = (time) => {
      this.lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    gsap.ticker.lagSmoothing(0);
  }

  initGSAPAnimations() {
    // Reveal headers & cards on scroll
    const revealElements = document.querySelectorAll('.reveal-on-scroll');

    revealElements.forEach((el) => {
      gsap.fromTo(
        el,
        {
          y: 20,
          opacity: 0,
          scale: 1
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.65,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 88%',
            once: true
          }
        }
      );
    });

    // Stagger service cards
    gsap.utils.toArray('.services-grid').forEach((grid) => {
      const cards = grid.querySelectorAll('.glass-card');
      gsap.fromTo(
        cards,
        { y: 60, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: grid,
            start: 'top 82%'
          }
        }
      );
    });

    // Draw only the three connections, in order, from dot to dot.
    gsap.utils.toArray('.timeline-container').forEach((container) => {
      const items = [...container.querySelectorAll('.timeline-item')];
      const connections = items.slice(0, -1);
      gsap.set(connections, { '--connector-progress': 0 });
      gsap.to(connections, {
        '--connector-progress': 1,
        duration: 0.65,
        stagger: 0.65,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: container,
          start: 'top 75%',
          once: true
        }
      });
    });
  }

  initStatsCounters() {
    const statCounters = document.querySelectorAll('.stat-counter');

    statCounters.forEach((counter) => {
      const target = parseFloat(counter.getAttribute('data-target'));
      const prefix = counter.getAttribute('data-prefix') || '';
      const suffix = counter.getAttribute('data-suffix') || '';

      ScrollTrigger.create({
        trigger: counter,
        start: 'top 85%',
        onEnter: () => {
          gsap.to(
            { val: 0 },
            {
              val: target,
              duration: 2.2,
              ease: 'power2.out',
              onUpdate: function () {
                const current = Math.floor(this.targets()[0].val);
                counter.innerText = `${prefix}${current}${suffix}`;
              }
            }
          );
        }
      });
    });
  }
}
